export const seoContent = {
    fr: {
        title: 'Meilleur Abonnement IPTV En France et Europe | Liguee1',
        description: "Abonnement IPTV premium : +79k chaînes, +249k films et séries, HD/4K, sport en direct, serveurs stables, support 24/7. Compatible avec tous vos appareils.",
    },
    es: {
        title: 'Mejor Suscripción IPTV en España y Europa | Liguee1',
        description: 'Suscripción IPTV premium: +79.000 canales, +249.000 películas y series, HD/4K, deporte en directo, servidores estables, soporte 24/7. Compatible con todos tus dispositivos.',
    },
};
